export default function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$rfpStorelocator = Object.assign({
        locationIcon: './../../images/Components/StoreLocator/location.png'
      }, config);
    }
  });
}
